import { Input, Button, Col, message } from "antd";
import { Form } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Auth, authCode, getCode } from "../../../controllers/auth";
import { REGEX_EMAIL } from "../../../shared/util";
import { useNavigate } from "react-router-dom";
import "./styles.scss";
import Time from "../CountDown";

interface Props {
  email?: string,
  showCodeField?: boolean,
  data?: any,
  okText?: string
  showDefaultbutton?: boolean
  onSuccessLogin?: (value: any) => void
}

const LoginFormCode = (Props: Props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingResend, setLoadingResend] = useState<boolean>(false);
  const [code, setcode] = useState<boolean>(Props.showCodeField || false);
  const [t] = useTranslation();
  const [resend, setResend] = useState<boolean>(false);

  useEffect(() => {
    form.setFieldsValue({ username: Props.email });
  }, []);

  const doAuth = async (data: any) => {
    try {
      if (data.username && !data.code) {

        setLoading(true);
        await getCode({
          username: data.username,
        });
        setcode(true);
      }

      if (data.username && data.code) {
        setLoading(true);

        const user = await authCode({
          username: data.username,
          code: data.code,
        });

        console.log("user auth", user);

        if (Props.onSuccessLogin) {
          Props.onSuccessLogin(user);
        }
      }

      setLoading(false);
    } catch (e) {

      message.error("Usuario no encontrado");
      setLoading(false);
    }
  };

  return (
    <Form
      form={form}
      name="Iniciar sesión"
      style={{ maxWidth: 600 }}
      onFinish={doAuth}
      autoComplete="off"
    >
      <Col>
        <label>{`*${t("EMAIL")}`}</label>
      </Col>

      <Form.Item
        wrapperCol={{ span: 24 }}
        name="username"
        rules={[
          {
            required: true,
            message: "Ingrese un email válido!",
            pattern: REGEX_EMAIL,
          },
        ]}
      >
        <Input />
      </Form.Item>
      <br />
      {code ? (
        <>
          {" "}
          <Col>
            <label>{`*${t("Codigo")}`}</label>
          </Col>
          <Form.Item
            wrapperCol={{ span: 24 }}
            name="code"
            rules={[
              {
                required: true,
                message: "Ingrese un código válido",
              },
            ]}
          >
            <Input />
          </Form.Item>{" "}
        </>
      ) : (
        null
      )}
      <Form.Item wrapperCol={{ span: 24 }}>
        <Button
          loading={loading}
          type="primary"
          size={"large"}
          block
          htmlType="submit"
        >
          {Props.okText || 'Iniciar'}</Button>
      </Form.Item>
      {code ? (
        <>
          <p className="flex-centered" style={{ margin: 0 }}>¿No recibiste tu código?</p>
          <p className="flex-centered" style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
            {!resend ? (
              <Time reset={false} countDownStart={30} onCountDownFinished={() => {
                setResend(true);
              }} />
            ) : (null)}
          </p>
          <p className="flex-centered">{resend ? (<Button loading={loadingResend}  type="primary" onClick={async () => {
            setLoadingResend(true);
            await getCode({
              username: form.getFieldValue('username'),
            });
            setResend(false)
            message.success(`Código enviado correctamente.`);
            setLoadingResend(false);
          }} size="small">Reenviar</Button>) : (null)}</p>
        </>
      ) : (null)}
    </Form>
  );
};

export default LoginFormCode;
